export default __webpack_public_path__ + "static/media/55_photo.e05ce81c.jpg";